<template>
  <div class="camplearn-report-pagearea primary-page">
    <div class="prev-wrapper" ref="poster">
      <div class="seriesdata-zone">
        <div class="time-box">
          {{ reportData.training_date }}至{{ reportData.finish_date }}
        </div>
        <div class="user-info" v-if="reportData.user">
          <img class="portrait" :src="reportData.user.portrait" alt="" />
          <div class="nickname" v-if="reportData.user">
            {{ reportData.user.nickname }}
          </div>
        </div>
        <!-- 学习进度 -->
        <div class="process-box">
          <div class="camp-box">
            <div class="camp-num">第{{ reportData.camp_num + 1 }}期</div>
            <div class="name">{{ reportData.name }}</div>
          </div>
          <div class="summary">{{ reportData.summary }}</div>
          <div class="data-box">
            <div class="atom">
              <div class="data">{{ reportData.learning_process }}%</div>
              <div class="text">学习进度</div>
            </div>
            <div class="atom">
              <div class="data">
                <template v-if="secondsToHM(reportData.total_time, 'h')">
                  {{ secondsToHM(reportData.total_time, "h") || 0 }}
                  <span>小时</span>
                </template>
                <template
                  v-if="
                    !(
                      secondsToHM(reportData.total_time, 'h') &&
                      !secondsToHM(reportData.total_time, 'm')
                    )
                  "
                >
                  {{ secondsToHM(reportData.total_time, "m") || 0 }}
                  <span>分钟</span>
                </template>
              </div>
              <div class="text">学习时长</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 学习分析 -->
      <div class="comm-box study-analysis-box">
        <h4 class="title">
          <img
            src="@/assets/learn_icon_lesson@2x.png"
            alt=""
            class="tit-icon"
          />
          <span class="text">学习分析</span>
        </h4>
        <ul
          class="desc-list"
          v-if="
            reportData.study_analysis &&
            reportData.study_analysis.analysis_desc.length
          "
        >
          <template
            v-for="(item, index) in reportData.study_analysis.analysis_desc"
          >
            <li class="desc" :key="index"><div class="item-icon"></div><div v-html="item"></div></li>
          </template>
        </ul>
        <div class="chart-box" style="display: flex; align-items: center; justify-content: center;">
          <canvas width="311" height="198" ref="my-canvas"></canvas>
        </div>
        <div class="quotes">
          <span class="text">
            <img
              src="@/assets/learn_icon_point1@2x.png"
              alt=""
              class="icon-point-left"
            />
            路是走出来的，不是想出来的
            <img
              src="@/assets/learn_icon_point2@2x.png"
              alt=""
              class="icon-point-right"
            />
          </span>
        </div>
      </div>

      <!-- 打卡分析 -->
      <div class="comm-box punch-analysis-box">
        <h4 class="title">
          <img
            src="@/assets/learn_icon_clockin@2x.png"
            alt=""
            class="tit-icon"
          />
          <span class="text">打卡分析</span>
        </h4>
        <ul
          class="desc-list"
          v-if="
            reportData.punch_analysis &&
            reportData.punch_analysis.punch_desc.length
          "
        >
          <template
            v-for="(item, index) in reportData.punch_analysis.punch_desc"
          >
            <li class="desc" :key="index"><div class="item-icon"></div><div v-html="item"></div></li>
          </template>
        </ul>
        <div class="chart-box" v-if="reportData.punch_analysis">
          <div
            class="punch-count-item"
            v-for="(item, index) in reportData.punch_analysis.punch_num"
            :key="index"
          >
            <div class="name">{{ item.name }}</div>
            <div class="punch-count-box">
              <div
                class="to-bar"
                :style="{ width: `${item.bar_width}px` }"
              ></div>
              <div
                class="count"
                :style="{ color: item.count ? '#FF9645' : '#999' }"
              >
                {{ item.count }}次
              </div>
            </div>
          </div>
        </div>
        <!-- 打卡记录 -->
        <div class="clock-record-box">
          <div class="title-box">
            <div class="left-subs">打卡记录</div>
            <div class="status-box">
              <i class="undone"></i>
              <span>未打卡</span>
              <i class="done"></i>
              <span>已打卡</span>
            </div>
          </div>
          <div class="calendar-box">
            <ClockInCalendar
              :clockInRange="clockInRange"
              :clockInDate="clockInDate"
              :againClockIn="cardReissueDate"
              :restDates="restDates"
              v-if="clockInRange"
            />
          </div>
        </div>
        <div class="quotes">
          <span class="text">
            <img
              src="@/assets/learn_icon_point1@2x.png"
              alt=""
              class="icon-point-left"
            />
            欲穷千里目，更上一层楼
            <img
              src="@/assets/learn_icon_point2@2x.png"
              alt=""
              class="icon-point-right"
            />
          </span>
        </div>
      </div>

      <div class="btm-logo">
        <img src="@/assets/logo_yojiang.png" alt="" />
      </div>
    </div>

    <!-- 弹窗：长图 -->
    <div class="long-pic-dialog" v-if="posterUrl">
      <div class="dialog-main">
        <div class="tips">
          <span class="text">长按保存图片，分享给微信好友或微信群</span>
        </div>
        <div class="poster-box">
          <img class="poster-img" :src="posterUrl" />
        </div>
      </div>
    </div>

    <!-- 底部按钮：生成长图按钮 -->
    <div id="footer-btn" class="footer-btn-box">
      <div class="draw-img-btn" @click.stop="drawImage">生成长图</div>
    </div>
  </div>
</template>

<script>
import html2canvas from 'html2canvas';
import { Toast } from 'vant';
import Cookies from 'js-cookie';
import ClockInCalendar from '@/components/clockInCalendar/index.vue';
import { getCampSeriesStudyReport } from '@/api/api';

export default {
  components: {
    ClockInCalendar,
  },
  data() {
    return {
      seriesId: 0,
      reportData: {},
      clockInRange: null, // 开营日期和结营日期
      clockInDate: [], // 已打卡日期
      cardReissueDate: [], // 补打卡日期
      restDates: [], // 休息日
      posterUrl: ''
    };
  },
  created() {
    const userId = Cookies.get('user_id');
    if (!userId) {
      this.$router.replace({
        path: '/login',
        query: {
          redirect: `/camp-learning-report/${this.$route.params.series_id}`,
        },
      });
      return;
    }
    this.seriesId = +this.$route.params.series_id;
    this.queryStudyReport();
  },
  mounted() {
    // this.queryStudyReport();
    setTimeout(() => {
      const footerBtn = document.getElementById('footer-btn');
      footerBtn.style.display = 'block';
    }, 1000);
  },
  methods: {
    queryStudyReport() {
      getCampSeriesStudyReport(this.seriesId).then((res) => {
        res.finish_date = res.finish_date.replace(/-/g, '.');
        res.training_date = res.training_date.replace(/-/g, '.');

        const dict = [];
        res.study_analysis.last_study.forEach((item) => {
          let xVal = item.last_date.replace(/-/g, '.');
          xVal = xVal.substr(5, 5);
          const yVal = Math.floor(item.seconds / 60);
          dict.push({
            x: xVal,
            y: yVal,
          });
        });

        this.reportData = res;
        this.drawStudyChart(dict);

        // 处理打卡分析数据
        const punchCountArr = [];
        res.punch_analysis.punch_num.forEach((item) => {
          punchCountArr.push(item.count);
        });

        this.$nextTick(() => {
          this.processPunchNumData(punchCountArr);
        });

        // 打卡记录
        const planList = res.punch_analysis.punch_calender.map(item => ({
          ...item,
          date_str: item.date_str.replace(/-/g, '/'),
        }));

        // 设置打卡范围
        this.clockInRange = {
          begDate: planList[0].date_str,
          endDate: planList[planList.length - 1].date_str,
        };

        // 筛选出已打卡的日期
        const clockInDate = planList.filter(item => item.punch_status === 1);
        if (clockInDate.length > 0) {
          this.clockInDate = clockInDate.map(item => item.date_str);
        }

        // 筛选出补卡的日期
        const cardReissueDate = planList.filter(
          item => item.punch_status === 2
        );

        if (cardReissueDate.length > 0) {
          this.cardReissueDate = cardReissueDate.map(item => item.date_str);
        }

        // 筛选出休息日
        const restDates = planList.filter(item => item.detail_id === 0);
        if (restDates.length) {
          this.restDates = restDates.map(item => item.date_str);
        }
      });
    },
    secondsToHM(seconds, type = 'h') {
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      if (type === 'h') {
        return hours;
      }
      return minutes;
    },
    drawStudyChart(dict) {
      // 数据源提取
      const len = dict.length;
      const xArr = [];
      const yArr = [];
      // eslint-disable-next-line camelcase
      const tempYArr = [];
      for (let i = 0; i < len; i++) {
        xArr.push(i * 43 + 27);
        tempYArr.push(dict[i].y);
      }

      const WIDTH = 311;
      const HEIGHT = 198;

      // eslint-disable-next-line prefer-spread
      const tempMinY = Math.min.apply(Math, tempYArr); // 最小值
      // eslint-disable-next-line prefer-spread
      const tempMaxY = Math.max.apply(Math, tempYArr); // 最大值

      if (tempMinY === 0 && tempMaxY === 0) {
        for (let i = 0; i < len; i++) {
          yArr.push(tempYArr[i] - tempMinY + 158); // 与最小的做比较
        }
      } else if (tempMinY === 0) {
        for (let i = 0; i < len; i++) {
          const length = 85 - 85 * (1 - tempYArr[i] / tempMaxY);
          yArr.push(length + 72.5);
        }
      } else {
        for (let i = 0; i < len; i++) {
          const length = 85 - 85 * (1 - tempYArr[i] / tempMaxY);
          yArr.push(length + 60);
        }
      }

      // eslint-disable-next-line prefer-spread
      const minY = Math.min.apply(Math, yArr);
      // eslint-disable-next-line prefer-spread
      const maxY = Math.max.apply(Math, yArr);

      const canvas = this.$refs['my-canvas'];
      const ctx = canvas.getContext('2d');

      // 获取像素比，放大比例为：devicePixelRatio / webkitBackingStorePixelRatio , 以下是兼容的写法
      const backingStore = ctx.backingStorePixelRatio
                   || ctx.webkitBackingStorePixelRatio
                   || ctx.mozBackingStorePixelRatio
                   || ctx.msBackingStorePixelRatio
                   || ctx.oBackingStorePixelRatio
                   || ctx.backingStorePixelRatio || 1;
      const ratio = (window.devicePixelRatio || 1) / backingStore;

      canvas.width = WIDTH * ratio;
      canvas.height = HEIGHT * ratio;

      canvas.style.width = `${WIDTH}px`;
      canvas.style.height = `${HEIGHT}px`;
      ctx.scale(ratio, ratio);

      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, WIDTH * ratio, HEIGHT * ratio);
      ctx.save();

      ctx.fillStyle = '#fff';
      ctx.fillRect(24, 45, 263, 113);

      // 标题
      ctx.font = '400 12px "PingFangSC Regular"';
      ctx.fillStyle = '#999999';
      ctx.textBaseline = 'top';
      ctx.fillText('近7天学习时长(分钟)', 24, 16);
      ctx.save();

      if (tempMinY === 0 && tempMaxY === 0) {
        ctx.font = '400 12px "PingFangSC Regular"';
        ctx.fillStyle = '#999999';
        ctx.textBaseline = 'top';
        ctx.textAlign = 'center';
        ctx.fillText('你还没开始学习哦，加油~', 155, 76);
        ctx.save();
      }

      // 画折线
      for (let i = 0; i < len; i++) {
        const x = xArr[i];
        const y = maxY - yArr[i] + minY;
        if (i === 0) {
          ctx.moveTo(x, y);
        } else {
          ctx.lineTo(x, y);
        }
      }
      ctx.lineWidth = 2;
      ctx.textBaseline = 'bottom';
      ctx.strokeStyle = '#FF9645';
      ctx.stroke();
      ctx.lineTo(285, 158);
      ctx.lineTo(27, 158);
      // 渐变填充颜色
      const gradient = ctx.createLinearGradient(24, 45, 24, 158);
      gradient.addColorStop(0, 'rgba(252, 177, 63, 0.3)');
      gradient.addColorStop(1, 'rgba(250, 140, 29, 0)');
      ctx.fillStyle = gradient;
      ctx.fill();

      // 画点
      for (let i = 0; i < len; i++) {
        const x = xArr[i];
        const y = maxY - yArr[i] + minY;
        const xMemo = dict[i].x;
        const yMemo = `${dict[i].y}分`;
        if (tempMaxY !== 0) {
          ctx.font = 'regular 10px "Source Han Sans Regular"';
          ctx.textAlign = 'center';
          ctx.fillStyle = '#191919';

          ctx.fillText(yMemo, x + 1, y - 10);
          ctx.save();
        }

        ctx.beginPath();
        ctx.arc(x, y, 3, 0, 2 * Math.PI); // 画点
        ctx.fillStyle = '#fff'; // 设置填充颜色
        ctx.fill(); // 开始填充
        ctx.strokeStyle = '#FF9645'; // 将线条颜色设置为蓝色
        ctx.stroke(); // stroke() 方法默认颜色是黑色（如果没有上面一行，则会是黑色）。
        ctx.save();

        ctx.font = 'regular 10px "Source Han Sans Regular"';
        ctx.textBaseline = 'bottom';
        ctx.textAlign = 'center';
        ctx.fillStyle = '#191919';

        ctx.fillText(xMemo, x, HEIGHT - 20, 40); // 画文字
      }
    },
    processPunchNumData(punchCountArr) {
      // eslint-disable-next-line prefer-spread
      const maxPunchCount = Math.max.apply(Math, punchCountArr); // 最大值

      const newDiv = document.createElement('div');
      newDiv.style.lineHeight = '12px';
      newDiv.style.fontSize = '12px';
      newDiv.style.display = 'inline-block';
      newDiv.style.visibility = 'hidden';
      newDiv.innerText = `${maxPunchCount}次`;
      document.body.appendChild(newDiv);

      const newDomW = Math.ceil(+window.getComputedStyle(newDiv).width.slice(0, -2))
        || newDiv.clientWidth;

      const punchCountBox = document.getElementsByClassName('punch-count-box')[0];
      const punchCountBoxW = Math.floor(
        +window.getComputedStyle(punchCountBox).width.slice(0, -2)
      ) || punchCountBox.clientWidth;

      this.reportData.punch_analysis.punch_num.forEach((item) => {
        item.bar_width = Math.max(
          (item.count * (punchCountBoxW - newDomW - 8)) / maxPunchCount,
          12
        );
      });
      this.$forceUpdate();
    },
    drawImage() {
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '图片生成中',
      });

      const ele = this.$refs.poster;

      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;

      setTimeout(() => {
        html2canvas(ele, {
          backgroundColor: '#fff', // 背景颜色
          dpi: 192, // 将分辨率提高到特定的dpi,默认值为96
          scale: 2, // 用于渲染的比例尺。默认为浏览器设备像素比率。默认值是1，手机端设置成2
          useCORS: true,
        }).then((canvas) => {
          const imgurl = canvas.toDataURL('image/png');

          if (imgurl.indexOf('image/png') === -1) {
            // 海报生成错误则重新生成
            setTimeout(() => {
              this.drawImage();
            }, 100);
          } else {
            this.posterUrl = imgurl;
            Toast.clear();
          }
        });
      }, 100);
    },
  },
};
</script>

<style lang="stylus" scoped>
@import './../../common/stylus/variable.styl';
@import './../../common/stylus/mixin.styl';

.camplearn-report-pagearea {
  margin-bottom: 84px;
  font-size: 16px;
}

.prev-wrapper {
  position: relative;
  background: #F6F7FA url('../../assets/learn_bg.png') top center no-repeat;
  background-size: contain;
  padding-bottom: 97px;

  .btm-logo {
    position: absolute;
    left: calc(50% - 32px);
    bottom: 32px;
    width: 64px;
    height: 33px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .seriesdata-zone {
    position: relative;
    width: 100%;
    padding-top: 28.6%;

    .time-box {
      width: 100%;
      padding-left: 6.934%;
      font-size: 12px;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 12px;
      text-align: left;
    }

    .user-info {
      display: flex;
      align-items: center;
      width: 100%;
      padding: 5.334% 6.4% 6.4%;

      .nickname {
        height: 36px;
        font-size: 16px;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 36px;
        no-wrap();
      }

      .portrait {
        min-width: 36px;
        height: 36px;
        margin-right: 6px;
        border-radius: 100%;
      }
    }

    .process-box {
      width: calc(100% - 32px);
      margin: auto;
      padding: 16px;
      background: #FFFFFF;
      box-shadow: 0px 12px 12px 0px rgba(0, 0, 0, 0.02);
      border-radius: 12px;

      .camp-box {
        display: flex;
        align-items: center;
        margin-bottom: 8px;

        .camp-num {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 22px;
          margin-right: 4px;
          padding: 0 8px;
          font-size: 14px;
          font-weight: 500;
          color: #FF9645;
          background: rgba(255, 150, 69, 0.16);
          border-radius: 12px;
        }

        .name {
          flex: 1;
          font-size: 18px;
          font-weight: 500;
          color: #191919;
          // line-height 22px
          no-wrap();
        }
      }

      .summary {
        margin-bottom: 12px;
        font-size: 12px;
        font-weight: 400;
        color: #999999;
        no-wrap();
      }

      .data-box {
        position: relative;
        display: flex;
        align-items: center;
        height: 70px;
        background: #F6F7FA;
        border-radius: 4px;

        &::after {
          content: '';
          display: block;
          position: absolute;
          top: 16x;
          left: calc(50% - 0.5px);
          width: 1px;
          height: 38px;
          background: #E7E7E7;
        }

        .atom {
          flex: 1;

          // display flex
          // align-items center
          .data {
            text-align: center;
            font-size: 20px;
            font-family: DINAlternate-Bold, DINAlternate;
            font-weight: bold;
            color: #191919;

            >span {
              font-size: 14px;
              font-weight: 400;
              color: #191919;
            }
          }

          .text {
            margin-top: 8px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            text-align: center;
          }
        }
      }
    }
  }

  .comm-box {
    width: calc(100% - 32px);
    margin: 24px auto auto;
    padding: 0 16px;
    background: #FFFFFF;
    box-shadow: 0px 12px 12px 0px rgba(0, 0, 0, 0.02);
    border-radius: 12px;

    .title {
      display: flex;
      align-items: center;
      width: 100%;
      height: 56px;
      margin-bottom: 23px;
      border-bottom: 0.5px solid #E7E7E7;

      .text {
        margin-left: 6px;
        font-weight: 500;
      }
    }

    &.punch-analysis-box {
      // .title {
      //   .text::before {
      //     background: url('../../assets/learn_icon_clockin@2x.png') center no-repeat;
      //     background-size: cover;
      //   }
      // }

      .chart-box {
        width: 100%;
        padding: 24px 16px;
        margin-top: 16px;
        background: #F6F7FA;
        border-radius: 4px;
        border: none;

        .punch-count-item {
          display: flex;
          align-items: center;
          width: 100%;

          &:not(:last-child) {
            margin-bottom: 24px;
          }

          .name {
            margin-right: 8px;
            width 24px
            font-size: 12px;
            font-weight: 400;
            color: #191919;
          }

          .punch-count-box {
            display: flex;
            align-items: center;
            // flex: 1;
            width: 80%;

            .to-bar {
              width: 12px;
              height: 12px;
              background: linear-gradient(270deg, #FA8C1D 0%, #FCB13F 100%);
              border-radius: 6px;
            }

            .count {
              width 25px
              margin-left: 8px;
              font-size: 12px;
              font-weight: 400;
              color: #999;
            }
          }
        }
      }

      .clock-record-box {
        .title-box {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          margin: 32px auto 16px;

          .subs {
            font-size: 14px;
            font-weight: 500;
            color: #191919;
          }

          .status-box {
            display flex
            align-items center
            font-weight: 400;
            color: #999;

            >span {
              font-size 12px
              transform scale(.8)
            }

            .undone {
              margin-right 4px
              width: 6px;
              height: 6px;
              background: rgba(231, 231, 231, 0.32);
              border: 0.5px solid #E7E7E7;
              border-radius: 100%;
            }

            .done {
              margin-left 10px
              margin-right 4px
              width: 6px;
              height: 6px;
              background: #FF9645;
              border: 0.5px solid #FF9645;
              border-radius: 100%;
            }
          }
        }

        .calendar-box {
          border-radius: 8px;
          border: 0.5px solid #E7E7E7;

          /deep/ .calendar {
            height: auto;
          }

          /deep/ .container {
            padding: 0 13px;
          }

          /deep/ .calendar .cal-month .cal-mon-day .day-box {
            width: 34px;
            height: 34px;
          }
        }
      }
    }

    .desc-list {
      .desc {
        position: relative;
        width: 100%;
        margin-bottom: 12px;
        padding-left: 14px;
        width: 297px;
        font-size: 14px;
        font-weight: 400;
        color: #191919;
        line-height: 20px;

        /deep/ em {
          font-size: 14px;
          font-weight: 400;
          color: #FF9645;
          font-style: normal;
        }

        .item-icon {
          position: absolute;
          top: 8px;
          left: 0;
          width 6px
          height 6px
          background: #FF9645;
          border-radius: 100%;
        }
      }
    }

    .chart-box {
      margin-top: 24px;
      width: 100%;
      border-radius: 8px;
      border: 1px solid #E7E7E7;
      overflow: hidden;

      img {
        width: 100%;
        object-fit: cover;
      }
    }

    .quotes {
      padding: 52px 0;
      font-size: 15px;
      font-weight: 400;
      color: #999999;
      text-align: center;

      .text {
        position: relative;
        display: inline-block;

        .icon-point-left {
          position: absolute;
          top: -20px;
          left: -26px;
          width: 18px;
          height: 12px;
        }

        .icon-point-right {
          position: absolute;
          bottom: -20px;
          right: -26px;
          width: 18px;
          height: 12px;
        }
      }
    }
  }
}

.long-pic-dialog {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1002;

  .dialog-main {
    display: flex;
    flex-direction: column;
    position: relative;
    width: 100%;
    max-width: 640px;
    height: 100%;
    margin: auto;
    // padding 51px 16px 32px
    background: #ffffff;

    .tips {
      width: 100%;
      height: 36px;
      background: rgba(0, 0, 0, 0.6);
      border-radius: 1px;
      font-size: 12px;
      font-weight: 300;
      color: #FFFFFF;
      line-height: 36px;
      text-align: center;

      &>span {
        display: inline-flex;
        align-items: center;

        &::before {
          content: '';
          display: inline-block;
          width: 16px;
          height: 16px;
          margin-right: 2px;
          background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAADXElEQVRYR8WXa8ifcxjHP9+RGDkmOYREEm3hlRdiCCOZw7Ctpmx74VAOtdlCMk1JOSVljs0hp9nGeOOUeEO8QCIphxzKaZZaOeSrb11P3f7+z/++7/+zeq566un/3P/79/ld3+v6Xtcjpjk0zefTCcD2DGAxcBlwNPA38B5wr6RXp3KJVgDbOwMvAGcALwFvA/nsbOAE4A5JK8aF6AJwf93+HElv2j4I+FPSj7avAO4Dlkl6eByIkQB12FfA1cAjlYkzAQMPSLrc9qPAacDBkvJ5r2gDuBTIzfYsiFtzMLAvcAEwF9gGvAUcI+mTXqfD6CK0fR1wk6S9bG8Edpd0ShXlL9EfeA74HDhR0jvbG2A+8AxwAPBQaX9+DrH9XWXjHuAa4EFJ329vgD2Ab4FzgWQjxdcEiDzPAz9I+qnv4Xm+SxdcC3w4CcB+wA7AX8BKSXf2hWgFqHTvVlL8MZCBXYG7gFPLEx4HZgMfAdenVduAOgEUxOYhEjwlabntI6oQ04Zp20PLsNYAh6dLJuuQqQKslXSL7bRlbnuzpNW2VwG3NW4fiS6SlE76T/QBeBkYlGAQYJ6kTbbnAG8URIwqPzMlHd8JwPZ5wDzgN+BuSV/aHiZBG8Bh9d3MitTEPq0AtpcBa4Ffq8LzndjvjQM18AqwTtLTDQkGM3CIpG9sLwdWSdq7C8BnwFbgJGAnYBNwXGn88UQXNF9ke2b5xVxJ7zYkGAtgC7Be0tKq/rw86Y+uG4YB1HMzJP1Tv6cL4qBzJG3rm4GYyZXAfEkvNiCyC2ydDGBUv/cF2BF4soowrRMJ4v27AEskZf73igKIU7YXYR0WiCeAdMPFw/q3D4HtlRnnkvZvLcKJB2zH42OtFwKXSMpaNlbYXg0skBTH7G5EBbEu9VAvWD8Oge0sMUdKOrkXQMmRTDwWKYCFkjJ+e4Xt9zMbJGWyds9AQ46s5YFYACyS9GxXAtvHAh8Ap0t6bSyAykQg4ukLgRWSMoZHhu0DgdeBLZKywv8vOg+jBsTttZxk5seyswd+Dfxeb4/dHgWcBVwF/Fz7Yla4qQE0JIlN31CLSDKTiAvmQhOXyoqWAl4jKe46NHplYPANtmMss2ppjWXnX7YMsS+ATyeseZROUwJoq4Euf592gH8BLpSGMOaZ3FAAAAAASUVORK5CYII=') center no-repeat;
          background-size: cover;
        }
      }
    }

    .poster-box {
      flex: 1;
      overflow: hidden;
      overflow-y: scroll;
      padding: 16px 16px 32px;

      .poster-img {
        width: 100%;
      }
    }
  }
}

.footer-btn-box {
  display: none;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  width: 100%;
  max-width: 640px;
  padding: 5px 16px 4px;
  background: #fff;

  .draw-img-btn {
    width: 100%;
    height: 40px;
    background: linear-gradient(270deg, #FA8C1D 0%, #FCB13F 100%);
    border-radius: 20px;
    font-size: 16px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 40px;
    text-align: center;
  }
}

.tit-icon {
  width: 24px;
  height: 24px;
}
</style>
